<template>
	<div class="capital contentBox gradient" ng-controller="palaceCapitalCtrl">
		<div class="contentBoxBody">
			<div ng-if="building.data.buildingType == 26 && !isCapital" class="contentBox gradient capitalChange">
				<h6 class="contentBoxHeader headerTrapezoidal">
					<div class="content"><span>Изменить столицу</span></div>
				</h6>
				<div class="contentBoxBody">
					<div><span>Если сделать выбранную деревню столицей, то все ресурсные поля в текущей столице выше 10 уровня (для города – 12) будут понижены до 10 уровня (для города – до 12), а здания, которые можно строить только в столице (например, каменотес), будут разрушены.</span></div>
					<div><span>Пожалуйста, обрати внимание, что столичный город производит 500 единиц культуры в день, в то время как обычный город - всего 200. Провозгласив своей новой столицей деревню, ты можешь уменьшить количество вырабатываемых единиц культуры.</span></div>
					<div class="horizontalLine"></div>
					<div>
						<!-- ngIf: isSitter -->
						<button ng-if="!isSitter" clickable="changeCapital();" class="clickable">
							<div class="content">
								<span ng-transclude="" class="innerText">
									<span translate=""><span>Изменить столицу</span></span>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
					</div>
					<!-- ngIf: error -->
				</div>
			</div>
			<div ng-if="building.data.buildingType != 26 || isCapital" class="contentBox gradient">
				<h6 class="contentBoxHeader headerTrapezoidal">
					<div class="content"><span>Особенности столицы</span></div>
				</h6>
				<div class="contentBoxBody">
					<div class="important"><span>Дворец определяет твою столицу, и может быть построен только в единственном числе.</span></div>
					<span><span>Столица — это сердце твоей империи. Чтобы перенести столицу, тебе нужен дворец. Есть особые правила:</span></span>
					<ul><ul class="uList"><li>Теоретически неограниченный уровень ресурсных полей (только в столице)</li> <li> Каменотес, который придает прочность зданиям (до 300%)</li> <li>Столицу нельзя захватить</li></ul></ul>
					<span><span>Столица может быть полностью уничтожена катапультами. В этом случае деревня или город с наибольшим населением автоматически станет новой столицей.</span></span>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>